import { render, staticRenderFns } from "./ActivityCostWarning.vue?vue&type=template&id=252b5cb2&"
import script from "./ActivityCostWarning.vue?vue&type=script&lang=js&"
export * from "./ActivityCostWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports